var React = require('react');
import { Link, browserHistory } from 'react-router';
var PropTypes = React.PropTypes;
var Auth = require("../../resources/auth");

import CircularProgress from 'material-ui/CircularProgress';
// import RaisedButton from 'material-ui/RaisedButton';
import '../../css/components/Students/students.css';
import '../../css/components/StudentAnalytics/ViewStudentMistakesBank.css';
// import { Pager } from 'react-bootstrap';

// import StudentsTable from './StudentsTable';
import MistakesBankTable from './MistakesBankTable';
import MistakesBankRow from './MistakesBankRow';
import StudentMistake from './StudentMistake';
var StudentRes = require('../../resources/student');
var AnalyticsRes = require('../../resources/analytics');

const STUDENT_STATUSES = [{
  // title: 'Draft',
  // code: 'draft',
  // value: ['self'],
  // actions: ['edit', 'delete'],
  // count: '-',
  cols: ['firstName', 'lastName', 'email', 'phone', 'residentialAddress', 'schoolName', 'class', 'SA2Grade', 'parentName' ,'parentNo', 'parentEmail', 'lastActivityDate'],
  notes: [
    ''
  ]
}];

const ITEM_LIMIT = 20;
var ViewStudentMistakesForDay = React.createClass({
  componentWillReceiveProps: function(nextProps) {
    this.setState({})
  },
  onSortChange: function(newSort) {
    // this.setState({
    //   sort: newSort,
    //   studentsData: [],
    //   isLoading: true,
    //   currentPager: 1,
    // }, () => {
    //   this.retrieveStudents();
    // });
  },
  getInitialState: function() {
    return {
        _id: '',
        firstName: '',
        lastName: '',
        email: '',
        statusMode: [],
        currentMode: {},
        isLoading: true,
        isRetrievingData: true,
        conceptTitle: "",
        worksheetTitle: "",
        worksheetTime: 0,
        mathButtonStyle: "mistakesButton mbSelected",
        scienceButtonStyle: "mistakesButton",
        mistakesData: [],
      // conceptsMap: null,
    };
  },
  handleChangeData: function(e) {
    // var update = {};
    // update[field] = e.target.value;
    // this.setState(update);
    // var searchName = this.state.searchStudentName;
    // this.setState({
    //   searchStudentName: e.target.value,
    //   studentsData: [],
    //   isLoading: true,
    //   currentPager: 1,
    //   sort: 'firstName'
    // }, () => {
    //   this.retrieveStudents(this.state.searchStudentName,this.state.searchStudentName);
    // });
  },
  componentDidMount: function() {

    var _this = this;
    var statusMode = this.state.statusMode;
    statusMode = STUDENT_STATUSES;
    var currentUser = Auth.getCurrentUser();

    var currentURL = window.location.href;
    currentURL = currentURL.split("/");
    var studentID = currentURL[currentURL.length-4]; //get the current class ID
    
    // if (currentUser.status.indexOf('reviewer') >= 0) return browserHistory.push('/review-tasks');
    // if (currentUser.role === 'admin') {
    //   statusMode = ADMIN_STATUSES;
    // } else  {
    //   statusMode = TEACHER_STATUSES;
    // }
    var currentMode = statusMode[0];
    if (this.props.location.query.mode) {
      var mode = this.props.location.query.mode,
          mappedMode = statusMode.filter((value) => {
            return value.code === mode
          })[0];
      if (mappedMode) currentMode = mappedMode;
    }
    this.setState({
        _id: studentID,
        isLoading: true,
        isRetrievingData: true,
        statusMode: statusMode,
        currentMode: currentMode
    }, function() {
      // var count = statusMode.length;
      // for (var i = 0; i < statusMode.length; i++) {
      //   this.countCollectionInMode(statusMode[i], function() {
      //     count--;
      //     if (count <= 0) _this.forceUpdate();
      //   });
      // }
    //   this.retrieveStudent();
      this.retrieveMistakes(0,0,1);
    });
  },
  retrieveStudent: function(fName,lName,callback) {
    callback = callback || function(){};
    var _this = this;
    var currentPager = this.state.currentPager;
    var options = {};
    options.skip = ITEM_LIMIT * (currentPager - 1);
    options.limit = ITEM_LIMIT;
    // options.sort = this.state.sort || "dateCreated";
    options.conditions = {};
    // options.conditions.status = {
    //   "$in": this.state.currentMode.value
    // }
    // if (!this.state.currentMode.canApplyAdminRole) {
    //   options.conditions.creator = Auth.getCurrentUser()._id;
    // }
    // if (this.state.currentMode.include) {
    //   options.include = this.state.currentMode.include;
    //   options.includeConditions = includeConditions[options.include];
    // }
          // console.log("state of mdoe is " + this.state.currentMode.cols);
    
    // var currentURL = window.location.href;
    // currentURL = currentURL.split("/");
    var studentID = this.state._id;//currentURL[currentURL.length-1]; //get the current class ID

    options.conditions.sort = this.state.sort || "firstName";
    // options.conditions.status = 'student';
    options.conditions.studentID = studentID;

    // var firstN = '';
    // var lastN = '';
    // if (fName) { firstN = fName; }
    // if (lName) { lastN = lName; }

    // options.conditions.sort = this.state.sort || "dateCreated";
    options.conditions.status = 'student';
    // options.conditions.firstName = firstN;
    // options.conditions.lastName = lastN;
    StudentRes.retrieveStudent(options, function(err, res) {
      // console.log("BEFORE DON sdfdsfsE!!");
      // if (callback) return callback(err, res);

    //   console.log("RES IS :" + res.lastName);


        _this.setState({
            _id: studentID,
            isLoading: false,
            firstName: res.firstName,
            lastName: res.lastName,
            // email: res.email,
            // phone: res.phone,
            // residentialAddress: res.metadata.residentialAddress,
            // schoolName: res.metadata.school,
            // schoolClassName: res.metadata.class,
            // SA2Grade: res.metadata.SA2Grade,
            // parentName: res.metadata.parentName,
            // parentNo: res.metadata.parentNo,
            // parentEmail: res.metadata.parentEmail,
            // lastActivityDate: '',
            // studentsData: (!err && res) ? res: [{}]
            }, () => {

                
                // var sData = _this.state.studentsData;
                // for (var i = 0; i < sData.length; i++) {

                //     var thisData = sData[i];
                //     var dDate = thisData['lastActivityDate'];
                //     var processDate = new Date(dDate);
                //     var dateToDisplay = processDate.toDateString();
                //     if (processDate.getFullYear()=='1970') { dateToDisplay = '-';}
                //     thisData['lastActivityDate'] = dateToDisplay;//processDate.getFullYear() + "/" + processDate.getMonth() + "/" + processDate.getDate();
                // }

                // _this.setState({
                //     studentsData: sData
                // });
            // console.log("DONE!!!");
            }
        );
    })
  },
  daysInMonth: function(iMonth, iYear) {
    return new Date(iYear, iMonth, 0).getDate();
  },
    renderHeaderRows: function() {
      var result = [],
          _this = this;
      
      result.push(<th key={'studentClassName'} className="sortable mbHeader">
              Date
              </th>);
      result.push(<th key={'noOfStudents'} className="sortable mbHeader">
              Concept
              </th>);
      result.push(<th key={'studentClassLevel'} className="sortable mbHeader">
              Wrong questions
              </th>);
      result.push(<th key={'dateCreated'} className="sortable mbHeader">
              Review
              </th>);
      return (
          <tr>
          {
              result.map((value, index) => {
              return value
              })
          }
          </tr>
      )
  },
  renderMistakesRows: function(fName,lName,callback) {

    callback = callback || function(){};
    var _this = this;

    var today = new Date();
    var yyyy = today.getFullYear();
    var mm = today.getMonth() + 1; //January is 0!
    var dd = today.getDate();//this.daysInMonth(mm,yyyy);//today.getDate(); //get last day for this month

    var result = [];

    for (var i = 0; i < 6; i++) { //get mistakes for last 6 months
      
      if (i > 0) {

        today.setDate(0); // 0 will result in the last day of the previous month
        yyyy = today.getFullYear(); //get the year for the previous month
        mm = today.getMonth() + 1; //get the previous month

        today.setDate(1); // 1 will result in the first day of the previous month

        if (mm === 0) { //if previous month is december, go back 1 year
          
          mm = 12; //and change it to 12 for december
          yyyy = today.getFullYear() - 1;
        }

        dd = this.daysInMonth(mm,yyyy); //get the last day of the previous month (i.e how many days the previous month have)
      
      } 
      // else {

      //   dd = today.getDate();
      // }

      result.push(
        <MistakesBankRow
          _id={_this.state._id}
          year={yyyy}
          month={mm}
          day={dd}
        />
      );
    }

    return result;
  },
  renderMistakes: function(fName,lName,callback) {

    callback = callback || function(){};
    var _this = this;

    var mistakes = _this.state.mistakes;
    var result = [];

    var misLength = mistakes.length;
    for (var x = 0; x < misLength; x++) {

      var thisMistake = mistakes[x];

      var studentAnswer = '';
      if (thisMistake.textInputs!=null) {

        if (thisMistake.textInputs.length>0) {
          studentAnswer = thisMistake.textInputs[0].text;
        }
      }

      if (thisMistake.textInputs.length > 1) {
        studentAnswer = thisMistake.textInputs[1].text;
      }

      if (studentAnswer==null) {
        studentAnswer = thisMistake.textInputs[0].result;
      }

      if (studentAnswer.includes("<math xmlns")) {

        var splitAns = studentAnswer.split("<mn>");
        var ans = splitAns[1]; //this will give us 0</mn>blablabla and we want the 0

        var sAns = ans.split("</mn>");
        studentAnswer = sAns[0]; //this will give us the 0
      }

      var correctAnswer = '';
      
      if (thisMistake.kquestionInfo.textInputAnswers!=null) {

        if (thisMistake.kquestionInfo.textInputAnswers.length > 0) {

          correctAnswer = thisMistake.kquestionInfo.textInputAnswers[0].text;
        }
      }

      var questionImage = '';
      if (thisMistake.kquestionInfo.image!=null) {
        
        if (thisMistake.kquestionInfo.image.length > 0) {
        
          questionImage = thisMistake.kquestionInfo.image;
        }
      }

      result.push(

        <StudentMistake
            questionNumber={x+1}
            userSelectedChoice={thisMistake.selectionChoices}
            questionInfo={thisMistake.kquestionInfo}
            questionPoints={thisMistake.numPoints}
            questionDesc={thisMistake.kquestionInfo.description}
            questionType={thisMistake.kquestionInfo.type}
            studentAnswer={studentAnswer}
            correctAnswer={correctAnswer}
            solution={thisMistake.kquestionInfo.solution}
            textInputs={thisMistake.textInputs}
            textInputAnswers={thisMistake.kquestionInfo.textInputAnswers}
            questionImage={questionImage}
        />
      );
    }

    result.push(

      <div>
        <hr/>

        {/*<button className="btn btn-success btnLoadMoreMistakes" onClick={_this.retrieveMistakes.bind(_this,1,0,0)} key={0}>
            <i className="fa fa-plus" style={{"paddingRight": "5px"}}></i>
            <span>Load more</span>
        </button>*/}

        <br/><br/>
      </div>
    );

    _this.setState({
      isLoading:false,
    });

    return result;
  },

  retrieveMistakes: function(skip,lt,gt,callback) {

    callback = callback || function(){};
    var _this = this;

    // var today = new Date();
    // var yyyy = today.getFullYear();
    // var mm = today.getMonth(); //January is 0!
    // var dd = this.daysInMonth(mm,yyyy);//today.getDate(); //get last day for this month


      // var lastDayOfMonth = 0;

        // today.setDate(0); // 0 will result in the last day of the previous month
        // yyyy = today.getFullYear(); //get the year for the previous month
        // mm = today.getMonth(); //get the previous month

        // today.setDate(1); // 1 will result in the first day of the previous month

        // if (mm === 0) { //if previous month is december, go back 1 year
          
        //   mm = 12; //and change it to 12 for december
        //   yyyy = today.getFullYear() - 1;
        // }

        // dd = this.daysInMonth(mm,yyyy); //get the last day of the previous month (i.e how many days the previous month have)
      

      // var currentPager = this.state.currentPager;
      var options = {};
      // options.skip = ITEM_LIMIT * (currentPager - 1);
      // options.limit = ITEM_LIMIT;
      // options.sort = this.state.sort || "dateCreated";

    //   options.concept_config = {};
    //   options.concept_config.root = "a234e6f6-a3ee-4bfe-9143-5c52f89ac84c"; //_id of "maths" in concepts table
    //   options.concept_config.leaf = true;
    //   options.concept_config.max_level = 4;

      options.conditions = {};

      var studentID = this.state._id;//currentURL[currentURL.length-1]; //get the current class ID

      // options.conditions.status = 'student';
      options.skip = skip;
      options.sort = "-dateCreated";

      options.conditions.creator = studentID;

      options.conditions0 = {};
      options.conditions0.allRight = false;
      options.conditions0.status = {
        $in: ["scored"]
      };

      var currentURL = window.location.href;
      currentURL = currentURL.split("/");
      
      var conceptID =  currentURL[currentURL.length-2]; //get the concept ID for this worksheet
      var dateValue = currentURL[currentURL.length-1];
      var yyyy = dateValue.substring(0,4);
      var mm = dateValue.substring(4,6);//timeValue.getDate();
      var dd = dateValue.substring(6,8);//timeValue.getMonth() + 1;
      var newDate = new Date(yyyy+"/"+mm+"/"+dd);
      
      var startD = Date.parse(newDate);
      var gtValue = startD;
      var ltValue = gtValue + 86399999; //add 24 hours

      if (gt === 0) {
        // gtValue = 0;
        // ltValue = lt;
      }
        // startD = startD/1000;

        // console.log("date IS : ", startD);

      options.conditions0.concepts = {
        $in: [conceptID]
      };
      options.conditions0.dateScored = {
          $lt:ltValue, //add 24 hours
          $gt:gtValue
      };

      options.conditions1 = {};

      options.include = "answer-required,kquestion-required";

      //TODO: call a controller to actually retrieve the mistakes from the db server
      AnalyticsRes.retrieveMistakesForSpecific(options, function(err, res) {

        if (res[0]!=null) {

          var cTitle = res[0].answers[0].metadata.mainConcepts[0].title; //concept title
          var wTitle = res[0].title; //worksheet title
          var wsTime = new Date(res[0].dateCreated);

          // Hours part from the timestamp
          var hours = wsTime.getHours();
          // Minutes part from the timestamp
          var minutes = wsTime.getMinutes();
          if (minutes < 10) { minutes = "0" + minutes; }
          // console.log("minutes IS ",minutes);

          var day = wsTime.getDate();
          var month = wsTime.getMonth() + 1;
          var year = wsTime.getFullYear();

          _this.setState({
            isLoading:true,
            isRetrievingData: false,
            conceptTitle: cTitle,
            worksheetTitle: wTitle,
            worksheetTime: hours + ":" + minutes + " " + day + "/" + month + "/" + year,
            mistakes:res[0].answers,
          });
        }
        // _this.setState({
        //   isLoading: false,
        //   mistakesData: (!err && res) ? res: [{}]
        // }, () => {

        // });
      });
    
  },
  showMath: function(_id) {
    this.setState({
        mathButtonStyle: "mistakesButton mbSelected",
        scienceButtonStyle: "mistakesButton",
    });
  },
  showScience: function(_id) {
    this.setState({
        mathButtonStyle: "mistakesButton",
        scienceButtonStyle: "mistakesButton mbSelected",
    });
  },
  render: function() {
    var _this = this;
    return (
        <div className="students">
            {
                (_this.state.isLoading && _this.state.isRetrievingData) && 
                <CircularProgress />
            }
            <div className="row createStudentRow">
                <div className="col col-md-2 DivlblCreateStudent">
                    <label className="lblCreateStudent"></label>
                </div>
                <div className="col col-md-10 DivTxtCreateStudent">
                    {
                    (!_this.state.isRetrievingData) &&
                    <label className="lblStudentInfo"><h3> Review Mistake - {_this.state.conceptTitle} </h3></label>
                    }
                </div>
            </div>
            <hr/>
            
            <div className="col col-md-10 DivTxtCreateStudent">
                {
                (!_this.state.isRetrievingData) &&
                <label className="lblStudentInfo mbWorksheetTitle"><h3> {_this.state.worksheetTitle} </h3>
                  <div className="mbTimestamp">- {_this.state.worksheetTime} </div>
                </label>
                }
            </div>
            <div className="col col-md-10 DivTxtCreateStudent">
              {
                (!_this.state.isRetrievingData) && 
                _this.renderMistakes()
              }
            </div>
        </div>
    );
  }

});

module.exports = ViewStudentMistakesForDay;



/** WEBPACK FOOTER **
 ** ./src/components/StudentAnalytics/ViewStudentMistakesForDay.js
 **/